export const selectResume = (state, id) => (state.resumes ? state.resumes.resumes[id] : null);
export const selectSyncState = state => state.resumes.syncing;
